/**
 * Changelog — novidades de cada deploy. Time lê; admin publica.
 */
import { api } from "@/lib/api";

export type ChangelogKind = "feature" | "improvement" | "fix" | "infra";

export interface ChangelogItem {
  kind: ChangelogKind;
  text: string;
}

export interface ChangelogEntry {
  id: string;
  version: string | null;
  title: string;
  published_at: string;
  is_published: boolean;
  items: ChangelogItem[];
  created_at: string;
  tested_count: number;
  tested_by_me: boolean;
}

export interface ChangelogInput {
  version?: string | null;
  title: string;
  published_at?: string | null;
  is_published?: boolean;
  items: ChangelogItem[];
}

export const changelogApi = {
  list: async (): Promise<ChangelogEntry[]> => (await api.get("/v1/changelog")).data,
  create: async (body: ChangelogInput): Promise<ChangelogEntry> =>
    (await api.post("/v1/changelog", body)).data,
  update: async (id: string, body: Partial<ChangelogInput>): Promise<ChangelogEntry> =>
    (await api.patch(`/v1/changelog/${id}`, body)).data,
  remove: async (id: string): Promise<void> => {
    await api.delete(`/v1/changelog/${id}`);
  },
  markTested: async (id: string): Promise<void> => {
    await api.post(`/v1/changelog/${id}/test`);
  },
  unmarkTested: async (id: string): Promise<void> => {
    await api.delete(`/v1/changelog/${id}/test`);
  },
};

export const KIND_OPTIONS: { value: ChangelogKind; label: string }[] = [
  { value: "feature", label: "Novidade" },
  { value: "improvement", label: "Melhoria" },
  { value: "fix", label: "Correção" },
  { value: "infra", label: "Infra" },
];

export const KIND_LABEL: Record<ChangelogKind, string> = {
  feature: "Novidade",
  improvement: "Melhoria",
  fix: "Correção",
  infra: "Infra",
};

export const KIND_VARIANT: Record<ChangelogKind, string> = {
  feature: "primary",
  improvement: "info",
  fix: "warning",
  infra: "muted",
};
